// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  text-align: center;
}

h2 {
  font-size: 20px;
  font-weight: 600;
  margin-block-end: 16px;
}

ion-icon {
  font-size: 70px;
}`, "",{"version":3,"sources":["webpack://./src/components/shared-components/components/error-loading-widget/error-loading-widget.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AACJ;;AAEA;EACI,eAAA;EACA,gBAAA;EACA,sBAAA;AACJ;;AAEA;EACI,eAAA;AACJ","sourcesContent":[":host {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 16px;\n    text-align: center;\n}\n\nh2 {\n    font-size: 20px;\n    font-weight: 600;\n    margin-block-end: 16px;\n}\n\nion-icon {\n    font-size: 70px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
